import React from "react";
import {
  Modal,
  ModalFooter,
  ModalButton,
  ModalBody,
  modalConnect,
} from "@modal";
import { postJSON } from "@js/helpers/communication.js";

import {
  cePromptChangeInterfaceCancel,
  cePromptChangeInterfaceError,
} from "@js/actions/studio/campaign_content_section/modal_prompt_change_interface.js";

const ModalPromptChangeInterface = modalConnect((props) => {
  let toggle = () => {
    let url = Routes.toggle_v1_editor_campaign_path(props.campaign_id);
    postJSON(url, {}, (data, err) => {
      if (data && !err && data.success) {
        document.location.reload();
      } else {
        props.dispatch(
          cePromptChangeInterfaceError(
            err ||
              (data && data.error) ||
              t("phrases.react_content.unknown_error"),
          ),
        );
      }
    });
  };
  return (
    <Modal
      title={t("phrases.warning")}
      onCancel={() => props.dispatch(cePromptChangeInterfaceCancel())}
    >
      <ModalBody>
        <p>
          <strong>{t("phrases.warning")}: </strong>
          {t(
            `phrases.react_content.interface_selector.warning_${
              props.use_v1_editor ? "upgrade" : "downgrade"
            }`,
          )}
        </p>
        {props.custom_warning && (
          <p dangerouslySetInnerHTML={{ __html: props.custom_warning }} />
        )}
        {props.validation_error && <p>{props.validation_error}</p>}
      </ModalBody>
      <ModalFooter>
        <ModalButton
          onClick={() => {
            props.dispatch(cePromptChangeInterfaceCancel());
          }}
          text={t("buttons.cancel")}
          diminished
        />
        <ModalButton onClick={toggle} text={t("phrases.proceed")} dangerous />
      </ModalFooter>
    </Modal>
  );
});

export default ModalPromptChangeInterface;
